// CREATE APP & ROUTER
import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'; 

// IMPORT VIEWS
import HomeCMS from "./views/HomeCMS.vue";
import PagesCMS from "./views/PagesCMS.vue";
import MediaCMS from "./views/MediaCMS.vue";
import DownloadsCMS from "./views/FilesCMS.vue";
import StatsCMS from "./views/StatsCMS.vue";
import ContactCMS from "./views/ContactCMS.vue";
import SettingsCMS from "./views/SettingsCMS.vue";
import LogIn from "./views/LogIn.vue";

const app = createApp(App);
const cors = require('cors');

const router = createRouter({
    history: createWebHistory(`/beheer`), 
    base: '/beheer',
    //history: createWebHistory(), 
    //base: '/',
    routes: [
        {path: '/', component: HomeCMS},
        {path: '/pages', component: PagesCMS},
        {path: '/media', component: MediaCMS},
        {path: '/files', component: DownloadsCMS},
        {path: '/stats', component: StatsCMS},
        {path: '/contacts', component: ContactCMS},
        {path: '/settings', component: SettingsCMS},
        {path: '/login', component: LogIn}
    ],
    // GO TO TOP AFTER VIEW CHANGE
    scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
});

app.use(router, cors());
app.mount('#app')